import { FlexContainer } from 'features/common/components/FlexContainer';
import { PunchupFieldLabel } from 'features/common/components/Punchup/primitives/forms/fields/PunchupFieldLabel';
import { PunchupToggle } from 'features/common/components/Punchup/primitives/forms/fields/PunchupToggle';
import { useFormContext } from 'react-hook-form';

// Own the prop shape green-side (was imported from the legacy dark-theme `Form/types`) so this
// primitive lifts into downstroke without a red-zone dependency.
export interface PunchupInputToggleProps {
	name: string;
	label: string;
	htmlFor?: string;
	required?: boolean;
}

export const PunchupInputToggle = ({ name, label, htmlFor, required }: PunchupInputToggleProps) => {
	const { watch, setValue } = useFormContext();
	const toggleValue = watch(name);

	return (
		<FlexContainer justifyContent="space-between" alignItems="center" margin="8px 0 0 0" width="100%">
			<PunchupFieldLabel label={label} htmlFor={htmlFor} required={required} />
			<PunchupToggle
				isChecked={toggleValue}
				handleClick={() => setValue(name, !toggleValue, { shouldDirty: true, shouldValidate: true })}
				name={name}
			/>
		</FlexContainer>
	);
};
